import React, { useState } from 'react';
import './FAQItem.css';

function FAQItem({ question, answer, isOpen = false }) {
  const [expanded, setExpanded] = useState(isOpen);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <div className="faq-item">
      <div className="faq-question" onClick={toggleExpand}>
        <h3>{question}</h3>
        <button className={`expand-btn ${expanded ? 'expanded' : ''}`}>
          {expanded ? '−' : '+'}
        </button>
      </div>
      {expanded && (
        <div className="faq-answer">
          <p>{answer}</p>
        </div>
      )}
    </div>
  );
}

export default FAQItem;